<template>
    <div class="card-pack">
        <div class="title">消费趋势
            <div class="condition-pack">
                <span v-for="(val, key) in periods"
                      :class="params.period===key && 'active'"
                      @click="changePeriod(key)"
                      :key="key"
                      class="item">{{val}}</span>
            </div>
        </div>
        <div class="trend-pack"
             ref="trend">
        </div>
    </div>
</template>

<script>
import echarts from 'echarts'
import API from '@/service/api'
export default {
    name: 'consumetrend',
    props: ['orgId'],
    data () {
        return {
            periods: {
                daily: '7天内',
                weekly: '一月内',
                monthly: '一年内'
            },
            params: {
                period: 'daily',
                orgId: ''
            }
        }
    },
    computed: {
    },
    watch: {
        orgId (val) {
            this.params.orgId = val
            this.getData()
        }
    },
    mounted () {
        this.getData()
    },
    methods: {
        getData () { // 获取消费趋势数据
            this.axios.get(this.urlFormat(API.OPE_STATISTICS_CONSUME), {
                params: this.params
            }).then((res) => {
                this.initChart(res)
            })
        },
        changePeriod (val) {
            this.params.period = val
            this.getData()
        },
        initChart (data) {
            const rechargeAmount = [] // 充值金额
            const orderAmount = [] // 支付订单
            const billAmount = [] // 已出账金额
            const invoiceAmount = [] // 已开票金额
            const xAxisData = [] // 时间
            let yMax = 1000 // 设置y轴线， 主要为了当金额数量过小时Y轴不至于看起来太小
            for (const i in data) {
                const item = data[i]
                rechargeAmount.push(item.rechargeAmount)
                item.rechargeAmount > yMax && (yMax = item.rechargeAmount)
                orderAmount.push(item.orderAmount)
                item.orderAmount > yMax && (yMax = item.orderAmount)
                billAmount.push(item.billAmount)
                item.billAmount > yMax && (yMax = item.billAmount)
                invoiceAmount.push(item.invoiceAmount)
                item.invoiceAmount > yMax && (yMax = item.invoiceAmount)
                xAxisData.push(item.period)
            }
            // period;
            this.myChart = echarts.init(this.$refs.trend)
            const option = {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'line'
                    }
                },
                legend: {
                    data: ['充值', '订单支付金额', '已出账', '已开票'],
                    itemWidth: 12,
                    itemHeight: 4,
                    top: 10,
                    itemGap: 30
                },
                grid: {
                    left: -55,
                    right: '0',
                    bottom: 13,
                    containLabel: true
                },
                xAxis: [
                    {
                        type: 'category',
                        data: xAxisData,
                        axisLabel: {
                            textStyle: {
                                color: '#808080'
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: '#e9e9e9'
                            }
                        }
                    }
                ],
                yAxis: [{
                    type: 'value',
                    max: yMax,
                    min: 0,
                    axisLabel: {
                        formatter: (val) => `￥${val.toLocaleString()}.00`,
                        margin: 80,
                        inside: false,
                        textStyle: {
                            align: 'left',
                            color: '#808080'
                        }
                    },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            type: 'dashed',
                            color: '#f3f3f3'
                        }
                    },
                    axisLine: {
                        lineStyle: {
                            color: '#e9e9e9'
                        }
                    },
                    show: true

                }],
                color: ['#ff6a01', '#ff9f5b', '#ffc297', '#fedec8'],
                barGap: 0,
                series: [
                    {
                        name: '充值',
                        type: 'bar',
                        barWidth: 10,
                        data: rechargeAmount
                    },
                    {
                        name: '订单支付金额',
                        type: 'bar',
                        barWidth: 10,
                        data: orderAmount
                    },
                    {
                        name: '已出账',
                        type: 'bar',
                        barWidth: 10,
                        data: billAmount
                    },
                    {
                        name: '已开票',
                        type: 'bar',
                        barWidth: 10,
                        data: invoiceAmount
                    }
                ]
            }
            this.myChart.setOption(option)
        }
    }
}
</script>

<style lang="less" scoped>
.trend-pack {
    height: 255px;
}
</style>
